<div
  class="flex flex-col gap-2"
  [ngClass]="{
    '2xl:flex-row 2xl:gap-8': !enforceCompactDesign,
    'max-w-[800px]': enforceCompactDesign
  }"
>

  <!-- LEFT SIDE -->
  <div class="flex flex-col justify-center grow">
    <mat-button-toggle-group #toggleGroup
                             (ngModelChange)="selectedSlot.set($event)"
                             [ngModel]="selectedSlot()"
                             class="min-w-[512px]"
                             hideSingleSelectionIndicator>

      @for (slot of slots(); let index = $index; let first = $first; let last = $last; track slot) {
        @if (!first && button.checked) {
          <div
            (mousedown)="onMousedown($event, index, toggleGroup, true)"
            class="z-10 w-[2px] relative bg-gray-400"
            [class.cursor-col-resize]="!readOnly"
          >
            <div class="rounded-full w-[24px] h-[24px] text-white left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 absolute bg-black/25">
              <mat-icon svgIcon="arrow-split-vertical"></mat-icon>
            </div>
          </div>
        }

        <mat-button-toggle #button="matButtonToggle"
                           [ngClass]="{
                              '!bg-rose-500/50': !slot.active() && slot !== selectedSlot(),
                              '!bg-lime-500/50': slot.active() && slot !== selectedSlot(),
                              '!bg-rose-500': !slot.active() && slot === selectedSlot(),
                              '!bg-lime-500': slot.active() && slot === selectedSlot()
                           }"
                           [ngStyle]="{ 'width': slot.width() * 100 + '%' }"
                           [value]="slot"
                           class="h-[30px] timeslot-toggle">
        </mat-button-toggle>

        @if (!last && button.checked) {
          <div
            (mousedown)="onMousedown($event, index, toggleGroup, false)"
            class="z-10 w-[2px] relative bg-gray-400"
            [class.cursor-col-resize]="!readOnly"
          >
            <div class="rounded-full w-[24px] h-[24px] text-white top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 absolute bg-black/25">
              <mat-icon svgIcon="arrow-split-vertical"></mat-icon>
            </div>
          </div>
        }
      }
    </mat-button-toggle-group>

    <div class="flex flex-row gap-4 justify-between">
      <span>00:00</span>
      <span>03:00</span>
      <span>06:00</span>
      <span>09:00</span>
      <span>12:00</span>
      <span>15:00</span>
      <span>18:00</span>
      <span>21:00</span>
      <span>24:00</span>
    </div>
  </div>

  <!-- RIGHT SIDE -->
  @if (selectedSlot(); as selectedSlot) {
    <div class="flex flex-row items-center gap-2 h-full"
         [ngClass]="{
         '2xl:items-stretch': !enforceCompactDesign
       }">

      <!-- BUTTON COLUMN -->
      <div class="flex flex-row gap-4 h-full"
           [ngClass]="{
           '2xl:flex-col 2xl:gap-2': !enforceCompactDesign
         }">

        <button (click)="addSlot()" [disabled]="readOnly" mat-stroked-button type="button">
        <span class="flex flex-row items-center gap-4">
          <mat-icon>add</mat-icon>
          <span class="uppercase" i18n>add</span>
        </span>
        </button>

        <button (click)="removeSlot()"
                [disabled]="!selectedSlot || slots().length <= 1 || readOnly"
                mat-stroked-button
                type="button">
        <span class="flex flex-row items-center gap-4">
          <mat-icon>remove</mat-icon>
          <span class="uppercase" i18n>remove</span>
        </span>
        </button>
      </div>

      <!-- ACTION COLUMN -->
      <div class="flex flex-row gap-4 items-center h-full"
           [ngClass]="{
           '2xl:flex-col 2xl:gap-2': !enforceCompactDesign
         }">

        <button (click)="openCopyDialog()" [disabled]="readOnly" mat-stroked-button type="button">
        <span class="flex flex-row items-center gap-4">
          <mat-icon>content_copy</mat-icon>
          <span class="uppercase" i18n>copy</span>
        </span>
        </button>

        <mat-slide-toggle (ngModelChange)="setSlotActiveState(selectedSlot, $event)"
                          [disabled]="readOnly"
                          [ngModel]="selectedSlot.active()">
          <ng-container i18n>Active</ng-container>
        </mat-slide-toggle>
      </div>

      <!-- START TIME -->
      <mat-form-field class="grow-0">
        <mat-label i18n>Start Time</mat-label>
        <mtx-datetimepicker #datetimePickerStart type="time"></mtx-datetimepicker>
        <input (ngModelChange)="selectedSlot.setStartFromDateTime($event); pushChanges()"
               [max]="selectedSlot.maxNewStartDateTime()"
               [disabled]="readOnly || selectedSlot.previous() === null"
               [min]="selectedSlot.minNewStartDateTime()"
               [mtxDatetimepicker]="datetimePickerStart"
               [ngModel]="selectedSlot.startDateTime()"
               matInput
               required>
        <mtx-datetimepicker-toggle [for]="datetimePickerStart" matSuffix></mtx-datetimepicker-toggle>
      </mat-form-field>

      <!-- END TIME -->
      <mat-form-field class="grow-0">
        <mat-label i18n>End Time</mat-label>
        <mtx-datetimepicker #datetimePickerEnd type="time"></mtx-datetimepicker>
        <input (ngModelChange)="selectedSlot.setEndFromDateTime($event); pushChanges()"
               [max]="selectedSlot.maxNewEndDateTime()"
               [disabled]="readOnly || selectedSlot.next() === null"
               [min]="selectedSlot.minNewEndDateTime()"
               [mtxDatetimepicker]="datetimePickerEnd"
               [ngModel]="selectedSlot.endDateTime()"
               matInput
               required>
        <mtx-datetimepicker-toggle [for]="datetimePickerEnd" matSuffix></mtx-datetimepicker-toggle>
      </mat-form-field>

    </div>
  }

</div>
